// src/utils/roles.js
// User Roles & Permissions Configuration

export const USER_ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  CUSTODIAN: 'custodian',
  USER: 'user'
};

export const ROLE_HIERARCHY = {
  super_admin: 4,
  admin: 3,
  custodian: 2,
  user: 1
};

export const PERMISSIONS = {
  // User Management
  APPROVE_USERS: ['super_admin', 'admin'],
  DELETE_USERS: ['super_admin'],
  CREATE_ADMIN: ['super_admin'],
  VIEW_ALL_USERS: ['super_admin', 'admin'],
  
  // Device Management
  VIEW_ALL_DEVICES: ['super_admin', 'admin'],
  VIEW_ASSIGNED_DEVICES: ['super_admin', 'admin', 'custodian'],
  MANAGE_DEVICE: ['super_admin', 'admin'],
  ASSIGN_CUSTODIAN: ['super_admin', 'admin'],
  UPDATE_DEVICE_INFO: ['super_admin', 'admin', 'custodian'],
  
  // Data Access
  APPROVE_DATA_REQUESTS: ['super_admin', 'admin'],
  APPROVE_API_REQUESTS: ['super_admin', 'admin'],
  APPROVE_DEPLOYMENT_REQUESTS: ['super_admin', 'admin'],
  VIEW_ALL_DATA: ['super_admin', 'admin'],
  VIEW_ASSIGNED_DATA: ['super_admin', 'admin', 'custodian'],
  
  // System Settings
  CONFIGURE_SYSTEM: ['super_admin'],
  VIEW_ANALYTICS: ['super_admin', 'admin'],
  VIEW_LOGS: ['super_admin', 'admin'],
};

// Check if user has specific permission
export const hasPermission = (userRole, permission) => {
  if (!userRole || !permission) return false;
  return PERMISSIONS[permission]?.includes(userRole) || false;
};

// Check if user can access resource
export const canAccessDevice = (userRole, deviceId, userAssignedDevices = []) => {
  if (userRole === USER_ROLES.SUPER_ADMIN || userRole === USER_ROLES.ADMIN) {
    return true;
  }
  
  if (userRole === USER_ROLES.CUSTODIAN) {
    return userAssignedDevices.includes(deviceId);
  }
  
  return false;
};

// Check if role is higher than another
export const isHigherRole = (userRole, targetRole) => {
  return ROLE_HIERARCHY[userRole] > ROLE_HIERARCHY[targetRole];
};

// Get role display name
export const getRoleDisplayName = (role) => {
  const names = {
    super_admin: 'Super Admin',
    admin: 'Admin',
    custodian: 'Custodian',
    user: 'User'
  };
  return names[role] || 'Unknown';
};

// Get role color
export const getRoleColor = (role) => {
  const colors = {
    super_admin: 'purple',
    admin: 'blue',
    custodian: 'green',
    user: 'gray'
  };
  return colors[role] || 'gray';
};

// Get role badge classes
export const getRoleBadgeClasses = (role) => {
  const classes = {
    super_admin: 'bg-purple-100 text-purple-800 border-purple-300',
    admin: 'bg-blue-100 text-blue-800 border-blue-300',
    custodian: 'bg-green-100 text-green-800 border-green-300',
    user: 'bg-gray-100 text-gray-800 border-gray-300'
  };
  return classes[role] || classes.user;
};